import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, c as serializeDataIfNeeded, t as toPathString, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * ContributorsApi - axios parameter creator
 * @export
 */
const ContributorsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary  (Auth roles: System)
         * @param {BulkEditTokenPost} [BulkEditTokenPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkEditPost: async (BulkEditTokenPost, options = {}) => {
            const localVarPath = `/v1/Contributors/BulkEditPost`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(BulkEditTokenPost, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContributorAward: async (id, options = {}) => {
            const localVarPath = `/v1/Contributors/DeleteContributorAward`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContributorCategory: async (id, options = {}) => {
            const localVarPath = `/v1/Contributors/DeleteContributorCategory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Deletes a contributor\'s editorial review (never a customer\'s); its photos go and the rating follows. (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReview: async (id, options = {}) => {
            const localVarPath = `/v1/Contributors/DeleteReview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {ContributorGetAllRequest} [ContributorGetAllRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (ContributorGetAllRequest, options = {}) => {
            const localVarPath = `/v1/Contributors/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ContributorGetAllRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {number} [Id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBycategoryId: async (Id, options = {}) => {
            const localVarPath = `/v1/Contributors/GetAllBycategoryId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (Id !== undefined) {
                localVarQueryParameter['Id'] = Id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCategoriesById: async (id, options = {}) => {
            const localVarPath = `/v1/Contributors/GetAllCategoriesById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllContributorAwardsById: async (id, options = {}) => {
            const localVarPath = `/v1/Contributors/GetAllContributorAwardsById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [Id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllContributorCategories: async (Id, options = {}) => {
            const localVarPath = `/v1/Contributors/GetAllContributorCategories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (Id !== undefined) {
                localVarQueryParameter['Id'] = Id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {ContributorGetAllRequest} [ContributorGetAllRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMapped: async (ContributorGetAllRequest, options = {}) => {
            const localVarPath = `/v1/Contributors/GetAllMapped`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ContributorGetAllRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthorsByTopCustomerRecommendations: async (options = {}) => {
            const localVarPath = `/v1/Contributors/GetAuthorsByTopCustomerRecommendations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [categoryId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBestSellingAuthorsByCategory: async (categoryId, options = {}) => {
            const localVarPath = `/v1/Contributors/GetBestSellingAuthorsByCategory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (categoryId !== undefined) {
                localVarQueryParameter['categoryId'] = categoryId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [customerId]
         * @param {string} [q]
         * @param {string} [sort]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByCustomerRecommendations: async (customerId, q, sort, page, psize, options = {}) => {
            const localVarPath = `/v1/Contributors/GetByCustomerRecommendations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (psize !== undefined) {
                localVarQueryParameter['psize'] = psize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById: async (id, options = {}) => {
            const localVarPath = `/v1/Contributors/GetById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Array<number>} [request_body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByIds: async (request_body, options = {}) => {
            const localVarPath = `/v1/Contributors/GetByIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(request_body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [url]
         * @param {string} [code]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContributorByUrl: async (url, code, options = {}) => {
            const localVarPath = `/v1/Contributors/GetContributorByUrl`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (url !== undefined) {
                localVarQueryParameter['url'] = url;
            }
            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [code]
         * @param {number} [pageIndex]
         * @param {number} [pageSize]
         * @param {string} [searchText]
         * @param {string} [startsWith]
         * @param {string} [sort]
         * @param {boolean} [isFeatured]
         * @param {Array<number>} [countryInclude]
         * @param {Array<number>} [countryExclude]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContributorsByCode: async (code, pageIndex, pageSize, searchText, startsWith, sort, isFeatured, countryInclude, countryExclude, options = {}) => {
            const localVarPath = `/v1/Contributors/GetContributorsByCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }
            if (pageIndex !== undefined) {
                localVarQueryParameter['pageIndex'] = pageIndex;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            if (searchText !== undefined) {
                localVarQueryParameter['searchText'] = searchText;
            }
            if (startsWith !== undefined) {
                localVarQueryParameter['startsWith'] = startsWith;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (isFeatured !== undefined) {
                localVarQueryParameter['isFeatured'] = isFeatured;
            }
            if (countryInclude) {
                localVarQueryParameter['countryInclude'] = countryInclude;
            }
            if (countryExclude) {
                localVarQueryParameter['countryExclude'] = countryExclude;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [contributorIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInfoByContributorIds: async (contributorIds, options = {}) => {
            const localVarPath = `/v1/Contributors/GetInfoByContributorIds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (contributorIds !== undefined) {
                localVarQueryParameter['contributorIds'] = contributorIds;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [entityId]
         * @param {string} [entity]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPerEntity: async (entityId, entity, options = {}) => {
            const localVarPath = `/v1/Contributors/GetPerEntity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }
            if (entity !== undefined) {
                localVarQueryParameter['entity'] = entity;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary A contributor\'s editorial reviews, each with its category and what it is about (any kind of item). (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReviewsById: async (id, options = {}) => {
            const localVarPath = `/v1/Contributors/GetReviewsById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {ContributorToken} [ContributorToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert: async (ContributorToken, options = {}) => {
            const localVarPath = `/v1/Contributors/Insert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ContributorToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {AwardToken} [AwardToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertContributorAward: async (AwardToken, options = {}) => {
            const localVarPath = `/v1/Contributors/InsertContributorAward`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(AwardToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {ContributorCategoryMapToken} [ContributorCategoryMapToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertContributorCategory: async (ContributorCategoryMapToken, options = {}) => {
            const localVarPath = `/v1/Contributors/InsertContributorCategory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ContributorCategoryMapToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary A new editorial review by a contributor, under the same rules as the Reviews page. It must be about an item that exists; the product rating, the details cache and the photo keys follow. (Auth roles: System)
         * @param {ReviewToken} [ReviewToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertContributorReview: async (ReviewToken, options = {}) => {
            const localVarPath = `/v1/Contributors/InsertContributorReview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ReviewToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id, options = {}) => {
            const localVarPath = `/v1/Contributors/Delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [contributorId]
         * @param {number} [entityId]
         * @param {string} [entity]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removePerEntity: async (contributorId, entityId, entity, options = {}) => {
            const localVarPath = `/v1/Contributors/RemovePerEntity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (contributorId !== undefined) {
                localVarQueryParameter['contributorId'] = contributorId;
            }
            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }
            if (entity !== undefined) {
                localVarQueryParameter['entity'] = entity;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [q]
         * @param {boolean} [enrich]
         * @param {string} [sort]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {string} [cids]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search: async (q, enrich, sort, page, psize, cids, options = {}) => {
            const localVarPath = `/v1/Contributors/Search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }
            if (enrich !== undefined) {
                localVarQueryParameter['enrich'] = enrich;
            }
            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (psize !== undefined) {
                localVarQueryParameter['psize'] = psize;
            }
            if (cids !== undefined) {
                localVarQueryParameter['cids'] = cids;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {ContributorToken} [ContributorToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (ContributorToken, options = {}) => {
            const localVarPath = `/v1/Contributors/Update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ContributorToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {AwardToken} [AwardToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContributorAward: async (AwardToken, options = {}) => {
            const localVarPath = `/v1/Contributors/UpdateContributorAward`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(AwardToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {ContributorCategoryMapToken} [ContributorCategoryMapToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContributorCategory: async (ContributorCategoryMapToken, options = {}) => {
            const localVarPath = `/v1/Contributors/UpdateContributorCategory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ContributorCategoryMapToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Edits a contributor\'s editorial review: only a live one (not a customer\'s, not deleted, not an earlier version), and it stays that contributor\'s. The ratings where it was and where it is, the details cache and the photo keys follow. (Auth roles: System)
         * @param {ReviewToken} [ReviewToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContributorReview: async (ReviewToken, options = {}) => {
            const localVarPath = `/v1/Contributors/UpdateContributorReview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(ReviewToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ContributorsApi - functional programming interface
 * @export
 */
const ContributorsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ContributorsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: System)
         * @param {BulkEditTokenPost} [BulkEditTokenPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkEditPost(BulkEditTokenPost, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkEditPost(BulkEditTokenPost, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContributorsApi.bulkEditPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteContributorAward(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteContributorAward(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContributorsApi.deleteContributorAward']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteContributorCategory(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteContributorCategory(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContributorsApi.deleteContributorCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Deletes a contributor\'s editorial review (never a customer\'s); its photos go and the rating follows. (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteReview(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteReview(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContributorsApi.deleteReview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {ContributorGetAllRequest} [ContributorGetAllRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(ContributorGetAllRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(ContributorGetAllRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContributorsApi.getAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {number} [Id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllBycategoryId(Id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllBycategoryId(Id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContributorsApi.getAllBycategoryId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllCategoriesById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllCategoriesById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContributorsApi.getAllCategoriesById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllContributorAwardsById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllContributorAwardsById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContributorsApi.getAllContributorAwardsById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [Id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllContributorCategories(Id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllContributorCategories(Id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContributorsApi.getAllContributorCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {ContributorGetAllRequest} [ContributorGetAllRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllMapped(ContributorGetAllRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllMapped(ContributorGetAllRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContributorsApi.getAllMapped']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuthorsByTopCustomerRecommendations(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuthorsByTopCustomerRecommendations(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContributorsApi.getAuthorsByTopCustomerRecommendations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [categoryId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBestSellingAuthorsByCategory(categoryId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBestSellingAuthorsByCategory(categoryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContributorsApi.getBestSellingAuthorsByCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [customerId]
         * @param {string} [q]
         * @param {string} [sort]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByCustomerRecommendations(customerId, q, sort, page, psize, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByCustomerRecommendations(customerId, q, sort, page, psize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContributorsApi.getByCustomerRecommendations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContributorsApi.getById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {Array<number>} [request_body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByIds(request_body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByIds(request_body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContributorsApi.getByIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [url]
         * @param {string} [code]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContributorByUrl(url, code, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContributorByUrl(url, code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContributorsApi.getContributorByUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [code]
         * @param {number} [pageIndex]
         * @param {number} [pageSize]
         * @param {string} [searchText]
         * @param {string} [startsWith]
         * @param {string} [sort]
         * @param {boolean} [isFeatured]
         * @param {Array<number>} [countryInclude]
         * @param {Array<number>} [countryExclude]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContributorsByCode(code, pageIndex, pageSize, searchText, startsWith, sort, isFeatured, countryInclude, countryExclude, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContributorsByCode(code, pageIndex, pageSize, searchText, startsWith, sort, isFeatured, countryInclude, countryExclude, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContributorsApi.getContributorsByCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [contributorIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInfoByContributorIds(contributorIds, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInfoByContributorIds(contributorIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContributorsApi.getInfoByContributorIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [entityId]
         * @param {string} [entity]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPerEntity(entityId, entity, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPerEntity(entityId, entity, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContributorsApi.getPerEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary A contributor\'s editorial reviews, each with its category and what it is about (any kind of item). (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReviewsById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReviewsById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContributorsApi.getReviewsById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {ContributorToken} [ContributorToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insert(ContributorToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insert(ContributorToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContributorsApi.insert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {AwardToken} [AwardToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insertContributorAward(AwardToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insertContributorAward(AwardToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContributorsApi.insertContributorAward']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {ContributorCategoryMapToken} [ContributorCategoryMapToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insertContributorCategory(ContributorCategoryMapToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insertContributorCategory(ContributorCategoryMapToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContributorsApi.insertContributorCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary A new editorial review by a contributor, under the same rules as the Reviews page. It must be about an item that exists; the product rating, the details cache and the photo keys follow. (Auth roles: System)
         * @param {ReviewToken} [ReviewToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insertContributorReview(ReviewToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insertContributorReview(ReviewToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContributorsApi.insertContributorReview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContributorsApi.remove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [contributorId]
         * @param {number} [entityId]
         * @param {string} [entity]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removePerEntity(contributorId, entityId, entity, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removePerEntity(contributorId, entityId, entity, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContributorsApi.removePerEntity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [q]
         * @param {boolean} [enrich]
         * @param {string} [sort]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {string} [cids]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async search(q, enrich, sort, page, psize, cids, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.search(q, enrich, sort, page, psize, cids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContributorsApi.search']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {ContributorToken} [ContributorToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(ContributorToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(ContributorToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContributorsApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {AwardToken} [AwardToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateContributorAward(AwardToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateContributorAward(AwardToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContributorsApi.updateContributorAward']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {ContributorCategoryMapToken} [ContributorCategoryMapToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateContributorCategory(ContributorCategoryMapToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateContributorCategory(ContributorCategoryMapToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContributorsApi.updateContributorCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Edits a contributor\'s editorial review: only a live one (not a customer\'s, not deleted, not an earlier version), and it stays that contributor\'s. The ratings where it was and where it is, the details cache and the photo keys follow. (Auth roles: System)
         * @param {ReviewToken} [ReviewToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateContributorReview(ReviewToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateContributorReview(ReviewToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContributorsApi.updateContributorReview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * ContributorsApi - factory interface
 * @export
 */
const ContributorsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ContributorsApiFp(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: System)
         * @param {BulkEditTokenPost} [BulkEditTokenPost]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkEditPost(BulkEditTokenPost, options) {
            return localVarFp.bulkEditPost(BulkEditTokenPost, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContributorAward(id, options) {
            return localVarFp.deleteContributorAward(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContributorCategory(id, options) {
            return localVarFp.deleteContributorCategory(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Deletes a contributor\'s editorial review (never a customer\'s); its photos go and the rating follows. (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReview(id, options) {
            return localVarFp.deleteReview(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {ContributorGetAllRequest} [ContributorGetAllRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(ContributorGetAllRequest, options) {
            return localVarFp.getAll(ContributorGetAllRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: CMS)
         * @param {number} [Id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBycategoryId(Id, options) {
            return localVarFp.getAllBycategoryId(Id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCategoriesById(id, options) {
            return localVarFp.getAllCategoriesById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllContributorAwardsById(id, options) {
            return localVarFp.getAllContributorAwardsById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [Id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllContributorCategories(Id, options) {
            return localVarFp.getAllContributorCategories(Id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {ContributorGetAllRequest} [ContributorGetAllRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMapped(ContributorGetAllRequest, options) {
            return localVarFp.getAllMapped(ContributorGetAllRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthorsByTopCustomerRecommendations(options) {
            return localVarFp.getAuthorsByTopCustomerRecommendations(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [categoryId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBestSellingAuthorsByCategory(categoryId, options) {
            return localVarFp.getBestSellingAuthorsByCategory(categoryId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [customerId]
         * @param {string} [q]
         * @param {string} [sort]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByCustomerRecommendations(customerId, q, sort, page, psize, options) {
            return localVarFp.getByCustomerRecommendations(customerId, q, sort, page, psize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById(id, options) {
            return localVarFp.getById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<number>} [request_body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByIds(request_body, options) {
            return localVarFp.getByIds(request_body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [url]
         * @param {string} [code]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContributorByUrl(url, code, options) {
            return localVarFp.getContributorByUrl(url, code, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [code]
         * @param {number} [pageIndex]
         * @param {number} [pageSize]
         * @param {string} [searchText]
         * @param {string} [startsWith]
         * @param {string} [sort]
         * @param {boolean} [isFeatured]
         * @param {Array<number>} [countryInclude]
         * @param {Array<number>} [countryExclude]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContributorsByCode(code, pageIndex, pageSize, searchText, startsWith, sort, isFeatured, countryInclude, countryExclude, options) {
            return localVarFp.getContributorsByCode(code, pageIndex, pageSize, searchText, startsWith, sort, isFeatured, countryInclude, countryExclude, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [contributorIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInfoByContributorIds(contributorIds, options) {
            return localVarFp.getInfoByContributorIds(contributorIds, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [entityId]
         * @param {string} [entity]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPerEntity(entityId, entity, options) {
            return localVarFp.getPerEntity(entityId, entity, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary A contributor\'s editorial reviews, each with its category and what it is about (any kind of item). (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReviewsById(id, options) {
            return localVarFp.getReviewsById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {ContributorToken} [ContributorToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert(ContributorToken, options) {
            return localVarFp.insert(ContributorToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {AwardToken} [AwardToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertContributorAward(AwardToken, options) {
            return localVarFp.insertContributorAward(AwardToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {ContributorCategoryMapToken} [ContributorCategoryMapToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertContributorCategory(ContributorCategoryMapToken, options) {
            return localVarFp.insertContributorCategory(ContributorCategoryMapToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary A new editorial review by a contributor, under the same rules as the Reviews page. It must be about an item that exists; the product rating, the details cache and the photo keys follow. (Auth roles: System)
         * @param {ReviewToken} [ReviewToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertContributorReview(ReviewToken, options) {
            return localVarFp.insertContributorReview(ReviewToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id, options) {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [contributorId]
         * @param {number} [entityId]
         * @param {string} [entity]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removePerEntity(contributorId, entityId, entity, options) {
            return localVarFp.removePerEntity(contributorId, entityId, entity, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [q]
         * @param {boolean} [enrich]
         * @param {string} [sort]
         * @param {number} [page]
         * @param {number} [psize]
         * @param {string} [cids]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search(q, enrich, sort, page, psize, cids, options) {
            return localVarFp.search(q, enrich, sort, page, psize, cids, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {ContributorToken} [ContributorToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(ContributorToken, options) {
            return localVarFp.update(ContributorToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {AwardToken} [AwardToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContributorAward(AwardToken, options) {
            return localVarFp.updateContributorAward(AwardToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {ContributorCategoryMapToken} [ContributorCategoryMapToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContributorCategory(ContributorCategoryMapToken, options) {
            return localVarFp.updateContributorCategory(ContributorCategoryMapToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Edits a contributor\'s editorial review: only a live one (not a customer\'s, not deleted, not an earlier version), and it stays that contributor\'s. The ratings where it was and where it is, the details cache and the photo keys follow. (Auth roles: System)
         * @param {ReviewToken} [ReviewToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContributorReview(ReviewToken, options) {
            return localVarFp.updateContributorReview(ReviewToken, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ContributorsApi - object-oriented interface
 * @export
 * @class ContributorsApi
 * @extends {BaseAPI}
 */
class ContributorsApi extends BaseAPI {
    /**
     *
     * @summary  (Auth roles: System)
     * @param {BulkEditTokenPost} [BulkEditTokenPost]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributorsApi
     */
    bulkEditPost(BulkEditTokenPost, options) {
        return ContributorsApiFp(this.configuration).bulkEditPost(BulkEditTokenPost, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributorsApi
     */
    deleteContributorAward(id, options) {
        return ContributorsApiFp(this.configuration).deleteContributorAward(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributorsApi
     */
    deleteContributorCategory(id, options) {
        return ContributorsApiFp(this.configuration).deleteContributorCategory(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Deletes a contributor\'s editorial review (never a customer\'s); its photos go and the rating follows. (Auth roles: System)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributorsApi
     */
    deleteReview(id, options) {
        return ContributorsApiFp(this.configuration).deleteReview(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {ContributorGetAllRequest} [ContributorGetAllRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributorsApi
     */
    getAll(ContributorGetAllRequest, options) {
        return ContributorsApiFp(this.configuration).getAll(ContributorGetAllRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: CMS)
     * @param {number} [Id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributorsApi
     */
    getAllBycategoryId(Id, options) {
        return ContributorsApiFp(this.configuration).getAllBycategoryId(Id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributorsApi
     */
    getAllCategoriesById(id, options) {
        return ContributorsApiFp(this.configuration).getAllCategoriesById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributorsApi
     */
    getAllContributorAwardsById(id, options) {
        return ContributorsApiFp(this.configuration).getAllContributorAwardsById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [Id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributorsApi
     */
    getAllContributorCategories(Id, options) {
        return ContributorsApiFp(this.configuration).getAllContributorCategories(Id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {ContributorGetAllRequest} [ContributorGetAllRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributorsApi
     */
    getAllMapped(ContributorGetAllRequest, options) {
        return ContributorsApiFp(this.configuration).getAllMapped(ContributorGetAllRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributorsApi
     */
    getAuthorsByTopCustomerRecommendations(options) {
        return ContributorsApiFp(this.configuration).getAuthorsByTopCustomerRecommendations(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [categoryId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributorsApi
     */
    getBestSellingAuthorsByCategory(categoryId, options) {
        return ContributorsApiFp(this.configuration).getBestSellingAuthorsByCategory(categoryId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [customerId]
     * @param {string} [q]
     * @param {string} [sort]
     * @param {number} [page]
     * @param {number} [psize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributorsApi
     */
    getByCustomerRecommendations(customerId, q, sort, page, psize, options) {
        return ContributorsApiFp(this.configuration).getByCustomerRecommendations(customerId, q, sort, page, psize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributorsApi
     */
    getById(id, options) {
        return ContributorsApiFp(this.configuration).getById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<number>} [request_body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributorsApi
     */
    getByIds(request_body, options) {
        return ContributorsApiFp(this.configuration).getByIds(request_body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [url]
     * @param {string} [code]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributorsApi
     */
    getContributorByUrl(url, code, options) {
        return ContributorsApiFp(this.configuration).getContributorByUrl(url, code, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [code]
     * @param {number} [pageIndex]
     * @param {number} [pageSize]
     * @param {string} [searchText]
     * @param {string} [startsWith]
     * @param {string} [sort]
     * @param {boolean} [isFeatured]
     * @param {Array<number>} [countryInclude]
     * @param {Array<number>} [countryExclude]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributorsApi
     */
    getContributorsByCode(code, pageIndex, pageSize, searchText, startsWith, sort, isFeatured, countryInclude, countryExclude, options) {
        return ContributorsApiFp(this.configuration).getContributorsByCode(code, pageIndex, pageSize, searchText, startsWith, sort, isFeatured, countryInclude, countryExclude, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [contributorIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributorsApi
     */
    getInfoByContributorIds(contributorIds, options) {
        return ContributorsApiFp(this.configuration).getInfoByContributorIds(contributorIds, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {number} [entityId]
     * @param {string} [entity]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributorsApi
     */
    getPerEntity(entityId, entity, options) {
        return ContributorsApiFp(this.configuration).getPerEntity(entityId, entity, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary A contributor\'s editorial reviews, each with its category and what it is about (any kind of item). (Auth roles: System)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributorsApi
     */
    getReviewsById(id, options) {
        return ContributorsApiFp(this.configuration).getReviewsById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {ContributorToken} [ContributorToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributorsApi
     */
    insert(ContributorToken, options) {
        return ContributorsApiFp(this.configuration).insert(ContributorToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {AwardToken} [AwardToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributorsApi
     */
    insertContributorAward(AwardToken, options) {
        return ContributorsApiFp(this.configuration).insertContributorAward(AwardToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {ContributorCategoryMapToken} [ContributorCategoryMapToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributorsApi
     */
    insertContributorCategory(ContributorCategoryMapToken, options) {
        return ContributorsApiFp(this.configuration).insertContributorCategory(ContributorCategoryMapToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary A new editorial review by a contributor, under the same rules as the Reviews page. It must be about an item that exists; the product rating, the details cache and the photo keys follow. (Auth roles: System)
     * @param {ReviewToken} [ReviewToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributorsApi
     */
    insertContributorReview(ReviewToken, options) {
        return ContributorsApiFp(this.configuration).insertContributorReview(ReviewToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributorsApi
     */
    remove(id, options) {
        return ContributorsApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {number} [contributorId]
     * @param {number} [entityId]
     * @param {string} [entity]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributorsApi
     */
    removePerEntity(contributorId, entityId, entity, options) {
        return ContributorsApiFp(this.configuration).removePerEntity(contributorId, entityId, entity, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [q]
     * @param {boolean} [enrich]
     * @param {string} [sort]
     * @param {number} [page]
     * @param {number} [psize]
     * @param {string} [cids]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributorsApi
     */
    search(q, enrich, sort, page, psize, cids, options) {
        return ContributorsApiFp(this.configuration).search(q, enrich, sort, page, psize, cids, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {ContributorToken} [ContributorToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributorsApi
     */
    update(ContributorToken, options) {
        return ContributorsApiFp(this.configuration).update(ContributorToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {AwardToken} [AwardToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributorsApi
     */
    updateContributorAward(AwardToken, options) {
        return ContributorsApiFp(this.configuration).updateContributorAward(AwardToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {ContributorCategoryMapToken} [ContributorCategoryMapToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributorsApi
     */
    updateContributorCategory(ContributorCategoryMapToken, options) {
        return ContributorsApiFp(this.configuration).updateContributorCategory(ContributorCategoryMapToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Edits a contributor\'s editorial review: only a live one (not a customer\'s, not deleted, not an earlier version), and it stays that contributor\'s. The ratings where it was and where it is, the details cache and the photo keys follow. (Auth roles: System)
     * @param {ReviewToken} [ReviewToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributorsApi
     */
    updateContributorReview(ReviewToken, options) {
        return ContributorsApiFp(this.configuration).updateContributorReview(ReviewToken, options).then((request) => request(this.axios, this.basePath));
    }
}

export { ContributorsApi, ContributorsApiAxiosParamCreator, ContributorsApiFactory, ContributorsApiFp };
//# sourceMappingURL=contributors-api.js.map
